import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Modal from "../AdDetails/Modal";
import ContactInfoModal from "./ContactInfoModal";
import {
  cardHover,
  cardOutline,
  fonts,
  headingFonts,
  primaryButtonStyles,
} from "../../Styles/Styles";

export default function SubServicesCard({
  serviceId,
  subService,
  serviceProviderId,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const loggedInUser = JSON.parse(localStorage.getItem("user"));

  // Check if the current URL matches `/expert/:id`
  const isExpertRoute = /^\/expert\/\w+/.test(location.pathname);

  const handleViewServiceClick = (subServiceId) => {
    navigate(`/service/${serviceId}/${subServiceId}`);
  };

  const handleBookNow = () => {
    if (loggedInUser) {
      setOpen(true);
    } else {
      setShowModal(true); // Show the modal if the user is not logged in
    }
  };

  const closeModal = () => {
    setShowModal(false); // Function to close the modal
  };

  return (
    <>
      <Card
        sx={{
          maxWidth: "auto",
          position: "relative",
          ...cardOutline,
          ...cardHover,
        }}
      >
        <CardMedia
          sx={{ height: 180, cursor: "pointer" }}
          image={subService.image}
          title={subService.name}
          onClick={() => handleViewServiceClick(subService._id)}
        />
        <CardContent>
          <Typography
            gutterBottom
            variant="body1"
            onClick={() => handleViewServiceClick(subService._id)}
            sx={{
              ...headingFonts,
              display: "inline",
              cursor: "pointer",
              color: "var(--primary-color)",
              "&:hover": { color: "inherit" },
            }}
          >
            <strong>{subService.name}</strong>
          </Typography>
          <Typography
            variant="body2"
            sx={{
              ...fonts,
              color: "text.secondary",
            }}
          >
            {subService.description}
          </Typography>
        </CardContent>
        {isExpertRoute && (
          <CardActions
            sx={{
              pl: 2, // Add padding to the right if needed
              marginTop: "-10px",
              justifyContent: "flex-start", // Align items to the right
            }}
          >
            <Button
              size="small"
              variant="contained"
              onClick={handleBookNow}
              sx={{ ...primaryButtonStyles }}
            >
              Book Now
            </Button>
          </CardActions>
        )}
      </Card>
      <ContactInfoModal
        open={open}
        setOpen={setOpen}
        onClose={() => setOpen(false)}
        service={subService}
        serviceProviderId={serviceProviderId}
      />
      <Modal open={showModal} onClose={closeModal} />
    </>
  );
}
